export function cut(value) {
	return new Intl.NumberFormat('en', {
		maximumFractionDigits: 2,
		notation: "compact",
		compactDisplay: "short"
	}).format(value);
}
